// Genre sanitization and cleaning utilities for AnimeCat
// Removes redundant, generic or unwanted tags such as 'animation', 'kids', 'infantil', etc.

export const BANNED_GENRES_LOWER = new Set([
  'animació',
  'animation',
  'animacion',
  'anime',
  'kids',
  'infantil',
  'infantils',
  'family',
  'família',
  'familia',
  'series',
  'sèries',
  'series tv',
  'tv series',
  'pel·lícules',
  'pel·licules',
  'pel·lícules d\'animació',
  'peliculas',
  'movie',
  'movies'
]);

/**
 * Strips out 'Animació', 'Kids', 'Infantil', 'Família', and other redundant categories
 */
export function cleanGenres(genres?: string[] | null): string[] {
  if (!genres || !Array.isArray(genres)) return [];
  
  return genres
    .filter(g => typeof g === 'string' && g.trim().length > 0)
    .map(g => g.trim())
    .filter(g => !BANNED_GENRES_LOWER.has(g.toLowerCase()));
}

/**
 * Extracts and returns a clean, unique list of genres starting with 'Tots'
 */
export function extractCleanGenreList(items: Array<{ genres?: string[] }>): string[] {
  const genreSet = new Set<string>();
  
  for (const item of items) {
    const cleaned = cleanGenres(item.genres);
    for (const g of cleaned) {
      genreSet.add(g);
    }
  }

  return ['Tots', ...Array.from(genreSet).sort((a, b) => a.localeCompare(b, 'ca'))];
}
